module.exports = __webpack_public_path__ + "/build/web/images/custom-made-textiles.fc98c22b8a90f26771d57ff219ba97d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/custom-made-textiles.jpg
// module id = 124
// module chunks = 13